import authService from './authService';
import config from '../config';

const METADATA_API_PREFIX = '/api/v1/users/me/metadata';

/**
 * Fetches all metadata records for the currently authenticated user.
 * @returns {Promise<Array<Object>>} An array of UserResourceMetadataResponse objects.
 * @throws {Error} If the request fails.
 */
export const getAllMyMetadata = async () => {
  const url = `${config.API_BASE_URL}${METADATA_API_PREFIX}`;
  try {
    const response = await authService.authFetch(url);
    if (!response.ok) {
      let errorDetail = `Failed to fetch user metadata: ${response.status}`;
      try {
        const errorData = await response.json();
        errorDetail = errorData.detail || errorDetail;
      } catch (e) {  }
      throw new Error(errorDetail);
    }
    const metadataList = await response.json();
    return metadataList;
  } catch (error) {
    console.error('[metadataApi] Error fetching all user metadata:', error);
    authService.trackNetworkError('getAllMyMetadata', error);
    throw error;
  }
};

/**
 * Sets or updates the bookmark status for a specific resource.
 * @param {string} resourceId - The ID of the resource to bookmark/unbookmark.
 * @param {boolean} isBookmarked - The new bookmark status.
 * @returns {Promise<Object>} The updated UserResourceMetadataResponse object.
 * @throws {Error} If the request fails.
 */
export const setBookmark = async (resourceId, isBookmarked) => {
  if (!resourceId) {
    throw new Error("Resource ID is required to set a bookmark.");
  }
  const url = `${config.API_BASE_URL}${METADATA_API_PREFIX}/${resourceId}`;
  const payload = {
    metadata: {
      bookmarked: isBookmarked,
    },
  };
  try {
    const response = await authService.authFetch(url, {
      method: 'PATCH',
      body: payload,
    });
    if (!response.ok) {
      let errorDetail = `Failed to set bookmark for ${resourceId}: ${response.status}`;
      try {
        const errorData = await response.json();
        errorDetail = errorData.detail || errorDetail;
      } catch (e) {  }
      throw new Error(errorDetail);
    }
    const updatedMetadata = await response.json();
    return updatedMetadata;
  } catch (error) {
    console.error(`[metadataApi] Error setting bookmark for ${resourceId}:`, error);
    authService.trackNetworkError('setBookmark', error);
    throw error;
  }
};

export default {
  getAllMyMetadata,
  setBookmark,
};